


















import { computed, defineComponent, onBeforeMount, onMounted, ref, useContext } from '@nuxtjs/composition-api'
import AddToCart from '~/components/AddToCart.vue';
import { useCart } from '~/composables';
import useLoader from '~/composables/useLoader';
import useProductPage from '~/composables/useProductPage';
import { trackBuyFromProductPage } from '~/helpers/trackings/product';
import { SKU_SEPARATOR } from '~/utils/constants/code';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS } from '~/utils/constants/product';

export default defineComponent({
    components: {
        AddToCart
    },
    setup(){
        const { product, paymentFrequencyChoosen, checkForceDisableAddToCart, modulesKeys, addModule, addToCartConfigs, bundleTipoConsegna } = useProductPage();
        const isCheckingCombining = ref(false);
        const forceDisableAddToCart = computed(() => checkForceDisableAddToCart(product.value)|| !canCombineInCart.value || isCheckingCombining.value);
        const { canCombineProductToCart, load } = useCart();
        const { app : { i18n } } = useContext();
        
        const canCombineInCart = ref<Boolean>(false)
        const canCombineLoaded = ref(false)
        onBeforeMount(async ()=>{
            await load({ realCart: true });
            canCombineInCart.value = await canCombineProductToCart(product.value);
            canCombineLoaded.value = true;
        })
        const selectedModulesSkus = computed(() => {
            return modulesKeys.value.map(el => el.split(SKU_SEPARATOR)[2])
        });
        if (product.value.requiredModules.length > 0) {
            product.value.requiredModules.forEach((module, index) => {
                addModule(module.product, true);
            });
        }

        const addToCartLabel = computed(()=>(
            isCheckingCombining.value?i18n.t('Adding to cart') as string
            : (canCombineInCart.value ? i18n.t('product_add_to_cart') : i18n.t('Not selectable')) as string));
            
        const checkCombineProduct = async ()=>{
            isCheckingCombining.value=true;
            canCombineInCart.value = await canCombineProductToCart(product.value);
            isCheckingCombining.value=false;
        }
        return {
            product,
            paymentFrequencyChoosen,
            selectedModulesSkus,
            trackBuyFromProductPage,
            forceDisableAddToCart,
            addToCartConfigs,
            bundleTipoConsegna,
            ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS,
            canCombineInCart,
            addToCartLabel,
            canCombineLoaded,
            checkCombineProduct,
        }
    }
})
